import { styled } from '@mui/material';

import { Button } from 'theSource/components';

export const InnerActionButtonStyled = styled(Button)({
  display: 'flex',
  justifyContent: 'flex-start',
}) as typeof Button;
